module.exports = __webpack_public_path__ + "img/video_processo_denuncia.a25aa83d.png";